import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ShoppingBagIcon } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';

/* v5 nav / footer / phone action bar as React, used on every page that is not a ported v5 prototype.
   Markup and class names mirror the approved v5 prototype (home + artist pages). */

const LINKS: {
  to: string;
  label: string;
  opt?: boolean;
  router?: boolean;
}[] = [{
  to: '/#crew',
  label: 'The Crew'
}, {
  to: '/#vault',
  label: 'The Vault',
  opt: true
}, {
  to: '/#lot',
  label: 'Up for Grabs'
}, {
  to: '/artists',
  label: 'Artists',
  router: true
}, {
  to: '/shop',
  label: 'Shop',
  router: true
}, {
  to: '/portfolio',
  label: 'Portfolio',
  router: true,
  opt: true
}, {
  to: '/blog',
  label: 'Blog',
  router: true,
  opt: true
}, {
  to: '/#faq',
  label: 'FAQ'
}, {
  to: '#visit',
  label: 'Visit'
}];
function Bulbs({
  n
}: {
  n: number;
}) {
  return <div className="tis-bulbs" aria-hidden="true" data-id="element-172" data-mp="1wwawr4eobds1">
      {Array.from({
      length: n
    }, (_, i) => <i key={i} style={{
      ['--i' as string]: i
    } as React.CSSProperties} data-id="element-173" data-mp="30p76m0thkjwt" />)}
    </div>;
}
export { Bulbs };
export function V5Nav() {
  const {
    count
  } = useCart();
  const {
    pathname
  } = useLocation();
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setSolid(window.scrollY > 30);
    on();
    window.addEventListener('scroll', on, {
      passive: true
    });
    return () => window.removeEventListener('scroll', on);
  }, []);
  useEffect(() => setOpen(false), [pathname]);
  return <nav className={`tis-nav ${solid || open ? 'solid' : ''} ${open ? 'open' : ''}`} aria-label="Main" data-id="element-174" data-mp="2811g0xfr40p2">
      <Link className="tis-logo" to="/" aria-label="Trip Ink Tattoo home" data-id="element-175" data-mp="2czcrfclp2j9e">
        <b className="tis-neon" data-id="element-176" data-mp="1yysbco75z1jl">TRIP INK</b>
        <small data-id="element-177" data-mp="1z14zjj3im853">TATTOO &middot; LAS VEGAS</small>
      </Link>
      <div className="tis-links" data-id="element-178" data-mp="23x3jmuht93zp">
        {LINKS.map(l => l.router ? <NavLink key={l.to} to={l.to} className={({
        isActive
      }) => `${l.opt ? 'opt' : ''} ${isActive ? 'active' : ''}`} onClick={() => setOpen(false)} data-id="element-179" data-mp="9i6fmd3zomvz">
              {l.label}
            </NavLink> : l.to.startsWith('#') ? <a key={l.to} href={l.to} className={l.opt ? 'opt' : ''} onClick={() => setOpen(false)} data-id="element-180" data-mp="3vxr4od62imjn">
              {l.label}
            </a> : <Link key={l.to} to={l.to} className={l.opt ? 'opt' : ''} onClick={() => setOpen(false)} data-id="element-181" data-mp="sh0v5oba1rd7">
              {l.label}
            </Link>)}
      </div>
      <div className="tis-navr" data-id="element-182" data-mp="jfubj6dc00fq">
        <Link className="tis-cart" to="/cart" aria-label={`Cart, ${count} items`} data-id="element-183" data-mp="jf1eix46cpas">
          <ShoppingBagIcon className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" data-id="element-184" data-mp="ehst8nnqc55b" />
          {count > 0 && <span data-id="element-185" data-mp="346lcqk0i3v5g">{count}</span>}
        </Link>
        <Link className="tis-btn sm solid" to="/book-now" data-id="element-186" data-mp="347mm8k1vc9l2">
          Book
        </Link>
        <button type="button" className="tis-burger" aria-label="Menu" aria-expanded={open} onClick={() => setOpen(o => !o)} data-id="element-187" data-mp="2z5nnjnh2q0ug">
          &#9776;
        </button>
      </div>
    </nav>;
}
export function V5Footer() {
  return <footer className="tis-visit" id="visit" data-id="element-188" data-mp="1npw3c3w8u39q">
      <div className="bigname" aria-hidden="true" data-id="element-189" data-mp="1notahqfd1qr6">
        TRIP INK
      </div>
      <div className="head" data-id="element-190" data-mp="1sh49mr2a18io">
        <Bulbs n={7} data-id="element-191" data-mp="1si5oz7qbsh67" />
        <span className="tis-eyebrow" data-id="element-192" data-mp="1sip9mw7d1jnx">Come find us</span>
        <h2 className="tis-neon" data-id="element-193" data-mp="1xemd41xiyvja">Visit</h2>
      </div>
      <div className="cols" data-id="element-194" data-mp="1xi1r11fgpyj4">
        <div data-id="element-195" data-mp="22e8ywzrf5k3p">
          <h4 data-id="element-196" data-mp="22dpkht0z9duf">Address</h4>
          <div className="addr" data-id="element-197" data-mp="22cxmkbjwr40z">
            5115 Dean Martin Drive #906
            <br data-id="element-198" data-mp="27ewrvqz7kb0k" />
            Las Vegas, NV 89118
            <small data-id="element-199" data-mp="27c0uq4v6pqd6">Front entrance to Hot Rod City. Look for the red neon.</small>
          </div>
          <div className="cta" data-id="element-200" data-mp="2bd46oga43294">
            <a className="tis-btn sm solid" href="https://www.google.com/maps/search/?api=1&query=5115+Dean+Martin+Drive+906+Las+Vegas+NV+89118" target="_blank" rel="noopener noreferrer" data-id="element-201" data-mp="d0cdfw1hdbpm">
              Get Directions
            </a>
            <Link className="tis-btn sm" to="/book-now" data-id="element-202" data-mp="3hv2a94zat78z">
              Book Your Full Day
            </Link>
          </div>
        </div>
        <div className="tis-contact" data-id="element-203" data-mp="3rut6pc7f5wbp">
          <h4 data-id="element-204" data-mp="3rtruv5ikx5sx">Reach Us</h4>
          <a href="tel:702-605-6633" data-id="element-205" data-mp="3rub4lyy2snvv">
            <b data-id="element-206" data-mp="3mvq9gdxokuea">CALL</b>702-605-6633
          </a>
          <a href="tel:702-586-5308" data-id="element-207" data-mp="3mx1esi6rya7i">
            <b data-id="element-208" data-mp="3mtx5x7id6qai">WALK-IN</b>702-586-5308
          </a>
          <a href="sms:702-408-8305" data-id="element-209" data-mp="2z770rxapyflo">
            <b data-id="element-210" data-mp="2z42osdr0ifkg">TEXT</b>702-408-8305
          </a>
          <a href="mailto:tripinklv@gmail.com" data-id="element-211" data-mp="2u7u98z8wkkcr">
            <b data-id="element-212" data-mp="2u4zot7pw2zjc">EMAIL</b>tripinklv@gmail.com
          </a>
          <div className="social" data-id="element-213" data-mp="38x0dj1mll0ri">
            <a className="tis-btn sm" href="https://www.instagram.com/tripinktattoo/" target="_blank" rel="noopener noreferrer" data-id="element-214" data-mp="38y1qjbn6bxbv">
              Instagram
            </a>
            <a className="tis-btn sm" href="https://www.facebook.com/tripinktattoo/" target="_blank" rel="noopener noreferrer" data-id="element-215" data-mp="2gecya2ua8fyc">
              Facebook
            </a>
          </div>
        </div>
        <div data-id="element-216" data-mp="qxhc6325hs4i">
          <h4 data-id="element-217" data-mp="qwzbmu8ggrqs">Hours</h4>
          <ul data-id="element-218" data-mp="qwfuhfqmq7dt">
            <li data-id="element-219" data-mp="vp8whvupr1m7">
              <span data-id="element-220" data-mp="vpsfzh00hy2c">Mon &ndash; Wed</span>
              <span data-id="element-221" data-mp="vqttrt8ewynr">12pm &ndash; 8pm</span>
            </li>
            <li data-id="element-222" data-mp="hydsawv5t8oy">
              <span data-id="element-223" data-mp="hyvnrr9zzivt">Thu &ndash; Sun</span>
              <span data-id="element-224" data-mp="hw13q0uwc02x">1pm &ndash; 10pm</span>
            </li>
          </ul>
          <p style={{
          marginTop: '.9em',
          fontSize: '.9em',
          color: '#b9b4bd',
          lineHeight: 1.5
        }} data-id="element-225" data-mp="lzz229ced6ux">
            Hours may vary. Call{' '}
            <a href="tel:702-586-5308" style={{
            color: '#ffe2a3',
            whiteSpace: 'nowrap'
          }} data-id="element-226" data-mp="1eo4or1n0h5xe">
              702-586-5308
            </a>{' '}
            to check availability.
          </p>
        </div>
      </div>
      <div className="copy" data-id="element-227" data-mp="15n6iecp3ombn">
        <span data-id="element-228" data-mp="15mdm65nrpf7r">
          &copy; Trip Ink Tattoo Company. Las Vegas, NV. &middot; <Link to="/shop" data-id="element-229" data-mp="3leud01gn62ra">Shop</Link> &middot; <Link to="/release-form" data-id="element-230" data-mp="3ldrpm3ij2ig4">Release form</Link> &middot;{' '}
          <Link to="/videos" data-id="element-231" data-mp="3qe71eqn5vhvz">Videos</Link> &middot; <Link to="/artist-interview" data-id="element-232" data-mp="3qf8ndq5ptosh">Artists: profile interview</Link>
        </span>
      </div>
    </footer>;
}
export function V5ActionBar() {
  return <nav className="tis-actbar" aria-label="Quick actions" data-id="element-233" data-mp="1qxueonumx6d1">
      <a href="tel:702-605-6633" data-id="element-234" data-mp="1r0fel7bdhc85">Call</a>
      <a href="sms:702-408-8305" data-id="element-235" data-mp="1m6ug7e5vag8f">Text</a>
      <Link className="solid" to="/book-now" data-id="element-236" data-mp="1m5t559ouptqp">
        Book
      </Link>
    </nav>;
}